import type { VisaoGeral } from "@/api/contrato";

/*
 * O atraso do relay da outbox, no rodapé da barra lateral — doc 06b §3.
 *
 * "A métrica que denuncia motor parado mora na moldura, não numa tela que
 * ninguém abre." Acima de 60 s significa relay parado (doc 06 §4.1), e a partir
 * daí nenhum boleto novo sai — mesmo com a API respondendo 200 em tudo.
 */
const LIMITE_DE_ATRASO_S = 60;

export function RodapeDoRelay({ visao }: { visao: VisaoGeral | undefined }) {
  const outbox = visao?.outbox;

  // Sem medida ainda: o rótulo aparece com travessão, e não some. Um rodapé que
  // some enquanto carrega faz a barra lateral pular de altura a cada ciclo.
  if (outbox === undefined || outbox.estado !== "ok") {
    return (
      <Moldura>
        <span className="text-texto-3">{textoDoEstado(outbox?.estado)}</span>
      </Moldura>
    );
  }

  const segundos = outbox.segundos ?? 0;
  const pendentes = outbox.pendentes ?? 0;
  const parado = segundos > LIMITE_DE_ATRASO_S;

  return (
    <Moldura>
      <span className={parado ? "text-falha" : "text-texto-2"}>
        <span className="dados">{segundos}s</span>
        {/*
          A contagem de pendentes acompanha o atraso porque atraso alto com um
          pendente é ruído, e atraso alto com mil é incidente.
        */}
        {pendentes > 0 && (
          <span className="text-texto-3"> · {pendentes} pendente{pendentes > 1 ? "s" : ""}</span>
        )}
      </span>
    </Moldura>
  );
}

function Moldura({ children }: { children: React.ReactNode }) {
  return (
    <div className="border-t border-fio px-3 py-2">
      <div className="rotulo">Atraso do relay</div>
      <div className="mt-[2px] text-[12px]">{children}</div>
    </div>
  );
}

function textoDoEstado(estado: string | undefined): string {
  /*
   * "Não configurado" e "indisponível" levam a ações OPOSTAS: um se resolve
   * editando um Secret, o outro chamando quem cuida do serviço. Dizer "serviço
   * fora" para configuração ausente manda o operador procurar um incidente que
   * não existe.
   */
  if (estado === "nao_configurado") return "não configurado";
  if (estado === "indisponivel") return "não foi possível medir";
  return "—";
}
